/**
 * Flag conventions
 * [platform]-[flag-type]-[feature-name]
 *
 * Platform:
 *   - all: all platform
 *   - android: android only
 *   - ios: ios only
 *   - web: web only
 * Flag Type:
 *   - b: boolean
 *   - v: variant
 * Feature name:
 *   - name of the feature with dash as separator
 *
 * Example:
 *   - web-b-split-order
 *   - all-v-language
 */

export enum FeatureFlagKeys {
  SPLIT_ORDER = 'all-b-split-order-eligibility',
  FAST_ORDER = 'web-b-fast-trade-eligibility',
  FAST_ORDER_DUPLICATE_BIDOFFER = 'web-b-fast-trade-duplicate-bidoffer',

  CHARTBIT_MAINTENANCE = 'chartbit_maintenance',
  CHARTBIT_DEBUG = 'chartbit_debug',
  CHARTBIT_DISABLE_AUTOSAVE = 'chartbit_disable_autosave',
  CHARTBIT_IFRAME_LOGGING = 'chartbit_iframe_logging',
}
